var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconError(_a) {
    var size = _a.size, colorVariant = _a.colorVariant, onClick = _a.onClick, icon = _a.icon, theme = _a.theme, additionalProps = __rest(_a, ["size", "colorVariant", "onClick", "icon", "theme"]);
    var iconTheme = useContext(ThemeContext);
    var color = setColor(iconTheme, colorVariant, 'primary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", __assign({}, additionalProps, { width: renderSize, height: renderSize, viewBox: "0 0 100 100", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }),
        React.createElement("g", { transform: "scale(4 4)" },
            React.createElement("path", { d: "M5.56497 0.292893C5.75251 0.105357 6.00686 0 6.27208 0H13.7279C13.9931 0 14.2475 0.105357 14.435 0.292893L19.7071 5.56497C19.8946 5.75251 20 6.00686 20 6.27208L20 13.7279C20 13.9931 19.8946 14.2475 19.7071 14.435L14.435 19.7071C14.2475 19.8946 13.9931 20 13.7279 20L6.27208 20C6.00686 20 5.75251 19.8946 5.56497 19.7071L0.292893 14.435C0.105357 14.2475 0 13.9931 0 13.7279V6.27208C0 6.00686 0.105357 5.75251 0.292893 5.56497L5.56497 0.292893ZM6.68629 2L2 6.68629L2 13.3137L6.68629 18L13.3137 18L18 13.3137L18 6.68629L13.3137 2H6.68629ZM13.7071 6.29292C14.0976 6.68345 14.0976 7.31661 13.7071 7.70714L11.4142 10L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L10 11.4142L7.70711 13.7071C7.31658 14.0977 6.68342 14.0977 6.29289 13.7071C5.90237 13.3166 5.90237 12.6834 6.29289 12.2929L8.58579 10L6.29287 7.70711C5.90234 7.31658 5.90234 6.68342 6.29287 6.29289C6.68339 5.90237 7.31655 5.90237 7.70708 6.29289L10 8.58582L12.2929 6.29292C12.6834 5.9024 13.3166 5.9024 13.7071 6.29292Z", fill: color }))));
}
//# sourceMappingURL=icon.error.component.js.map